// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/common/components/popover/ProcessTypePopover.less
// module id = 1813
// module chunks = 0